import { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { OrderDirectionOption, PageSizeOption } from '@/graphql/generated';

type ListFilterControlsProps = {
  search: string;
  onSearchChange: (value: string) => void;
  orderDirection: OrderDirectionOption;
  onOrderChange: (value: OrderDirectionOption) => void;
  pageSize?: PageSizeOption;
  onPageSizeChange?: (size: PageSizeOption) => void;
  showPageSizeSelector?: boolean;
};

const FiltersRow = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const Input = styled.input`
  padding: 0.35rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  min-width: 200px;
  font-size: 0.9rem;
`;

const Select = styled.select`
  padding: 0.35rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  background: white;
  font-size: 0.9rem;
`;

const ListFilterControlsComponent = ({
  search,
  onSearchChange,
  orderDirection,
  onOrderChange,
  pageSize,
  onPageSizeChange,
  showPageSizeSelector = false,
}: ListFilterControlsProps) => {
  const [internalSearch, setInternalSearch] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => {
      onSearchChange(internalSearch);
    }, 300);
    return () => clearTimeout(handler);
  }, [internalSearch, onSearchChange]);

  useEffect(() => {
    setInternalSearch(search);
  }, [search]);

  return (
    <FiltersRow>
      <Input
        type="text"
        placeholder="Buscar..."
        value={internalSearch}
        onChange={(e) => setInternalSearch(e.target.value)}
      />
      <Select
        value={orderDirection}
        onChange={(e) => onOrderChange(e.target.value as OrderDirectionOption)}
      >
        <option value={OrderDirectionOption.Asc}>Ascendente</option>
        <option value={OrderDirectionOption.Desc}>Descendente</option>
      </Select>
      {showPageSizeSelector && onPageSizeChange && pageSize && (
        <Select
          value={pageSize}
          onChange={(e) => onPageSizeChange(e.target.value as PageSizeOption)}
        >
          <option value={PageSizeOption.TwentyFive}>25</option>
          <option value={PageSizeOption.Fifty}>50</option>
          <option value={PageSizeOption.SeventyFive}>75</option>
          <option value={PageSizeOption.OneHundred}>100</option>
        </Select>
      )}
    </FiltersRow>
  );
};

export const ListFilterControls = memo(ListFilterControlsComponent);
